export enum SYSTEM {
  B2B = 'B2B',
  DEALER = 'DEALER',
}

const SYSTEM_CHECKERS = [
  { code: SYSTEM.B2B, match: /^.*samsungb2bsvc.*$/i },
  { code: SYSTEM.B2B, match: /^.*b2b.dkrabbit.com.*$/i },
  { code: SYSTEM.DEALER, match: /'*'/i },
];
export default class System {
  static getSystem = () => {
    const found = SYSTEM_CHECKERS.find(x => x.match.test(window.location.hostname));
    return found?.code || SYSTEM.DEALER;
  }

  static isDealerSystem = () => {
    return this.getSystem() !== SYSTEM.B2B;
  };
}
